package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_01_03_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes enjoying a feast with Lord Fox.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Lord Fox speaks with each of the heroes, learning their backstory and answering some questions.")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Lord Fox is known as “Thad” to his friends.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Korvis follows Ellewen, Lady of Luck, Mistress of the Wild.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Lord Fox once visited the Feywild.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Lord Fox has real motivational speaker energy.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("On the Open Sea, Lord Fox defeated a Cambion and in the hold of the demon’s ship was the Shard of Concar.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Lord Fox has heard of Dazzlecraft and Tinkerrock’s work in the south east.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Lord Pent’s first name is “Verudis.”")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Lord Fox is a scion of the Dorvidian Empire but decided to split with the Dorvidians.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Lord Pent is a close advisor of the Dorvidian Emperor.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Lord Fox appears to be willing to give the heroes his Shard of Concar, but he wants to challenge the heroes — do they know themselves? The heroes choose Tuesday as their champion for the challenge. Lord Fox states that the heroes may receive the Shard of Concar either way, but if they succeed at his challenge, he has some property in Freeburg that he could sell them at a discounted price.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes follow Lord Fox to an arena. Lord Fox says, “Mr Sonbottom, are you prepared?” Tuesday replies, “I have no idea what’s going on.” A duplicate of Tuesday appears opposite of him in the arena, but the duplicate has ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("dark hair")
        }
        org.jetbrains.compose.web.dom.Text(". Tuesday and his dark haired twin battle each other with mirror images and attempts at banish (counterspelled). Tuesday casts animate objects to create a coin swarm that chews through his dark haired twin. Lord Fox congratulates Tuesday.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Lord Fox tells the heroes that he owns a property on the west side of Freeburg worth 200,000 gold that he would sell to the heroes at the low price of 50,000 gold. The heroes thank him for his generosity and setup a viewing of the property on Shimmer 10. Lord Fox gives the heroes his Shard of Concar.")
    }
}
